import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useSidebarContext } from './SidebarContext';
const colorClasses = {
    blue: 'bg-blue-50 dark:bg-blue-900',
    alternative: 'bg-alternative-50 dark:bg-alternative-900',
    dark: 'bg-dark-50 dark:bg-dark-900',
    light: 'bg-light-50 dark:bg-light-900',
    green: 'bg-green-50 dark:bg-green-900',
    red: 'bg-red-50 dark:bg-red-900',
    yellow: 'bg-yellow-50 dark:bg-yellow-900',
    purple: 'bg-purple-50 dark:bg-purple-900',
};
const SidebarCTA = ({ children, className, color = 'blue', ...rest }) => {
    const { collapsed } = useSidebarContext();
    return collapsed ? (_jsx(_Fragment, {})) : (_jsx("div", { className: classNames('mt-6 rounded-lg p-4', colorClasses[color], className), "data-testid": "sidebar-cta", ...rest, children: children }));
};
SidebarCTA.displayName = 'Sidebar.CTA';
export default SidebarCTA;
